import { AccountCreditCardIcon } from './AccountCreditCardIcon';

/**
 * author: Jeff Anders
 * id 5AE7D856-B33F-4C37-B7A3-F05DD4D345DD
 * name account-credit-card
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-credit-card.svg
 * tags
 * - Account / User 
 * - Banking 
 */
export const CardholderIcon = AccountCreditCardIcon;
export default CardholderIcon